// firmLinkHealth.js
//
// Companion to `errorLog.js`. Exposes the two diagnostic RPCs from
// migration 131 as console-accessible helpers, so a support agent on
// the phone can ask a stuck user to type a single command in DevTools
// and either see what's wrong or fix it themselves.
//
// The user-facing flow is:
//
//   * "Open DevTools → Console, type window.__dfHealth() — read me what it says."
//     The output is JSON describing whether the user's auth uid is
//     linked to a firm, whether their employees row matches, and a
//     human-readable hint about what to do.
//
//   * If the diagnostic says the link is repairable, support asks:
//     "Now type window.__dfRepair()." That fires the RPC, fixes the
//     users.firm_id, and prompts the user to refresh.
//
// These RPCs are SECURITY DEFINER but only ever touch the caller's own
// row (auth.uid() is the key), so exposing them on `window` is safe.

import { supabase } from '../services/supabaseClient';

export async function firmLinkHealth() {
  const { data, error } = await supabase.rpc('firm_link_health');
  if (error) return { error: error.message || String(error) };
  return data;
}

export async function repairMyFirmLink() {
  const { data, error } = await supabase.rpc('repair_my_firm_link');
  if (error) return { error: error.message || String(error) };
  return data;
}

// Console helpers. Pattern matches `window.__dfErrorLog()` from
// errorLog.js — short names, no UI, safe to invoke ad-hoc. Each
// returns a Promise so the user sees the result inline in the console.
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-underscore-dangle
  window.__dfHealth = firmLinkHealth;
  // eslint-disable-next-line no-underscore-dangle
  window.__dfRepair = repairMyFirmLink;
}
